import React from 'react';
import Link from 'next/link';
import Box from '@mui/material/Box';
import Svg from 'components/Svg';
import { AuthSession } from 'hooks/useAuth';
import { LogoWrapper } from './styled';

function Logo(): JSX.Element {
  const auth = AuthSession();
  const userIsAuthenticated = auth.isAuthenticated;
  const logoRedirectionUrl = userIsAuthenticated ? '/myaccount/' : '/';
  return (
    <LogoWrapper>
      <Box
        component="span"
        sx={{
          display: { xs: 'none', sm: 'none', md: 'inherit', lg: 'inherit' }
        }}>
        <Link href={logoRedirectionUrl} passHref>
          <Svg
            name="keenLogoRibbon"
            width={{ md: '85px', lg: '100px' }}
            height={{ md: '85px', lg: '100px' }}
          />
        </Link>
      </Box>
      <Box
        component="span"
        sx={{
          display: { xs: 'inherit', sm: 'inherit', md: 'none', lg: 'none' }
        }}>
        <Link href={logoRedirectionUrl} passHref>
          <Svg name="keenLogoDefault" width="68px" height="20px" />
        </Link>
      </Box>
    </LogoWrapper>
  );
}

export default Logo;
